/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IHerbalIntroBlockViewProps } from './herbal-intro-block';

/**
 * Render Additional Content.
 * @param additionalContent - Additional content view props.
 * @returns JSX Element.
 */

const HerbalIntroBlockView: React.FC<IHerbalIntroBlockViewProps> = props => {
    const { contentBlockContainer, imageContainer, detailsContainer, text, image, contentBlockAnchorTag, imageLink } = props;

    if (imageLink) {
        return (
            <Module {...contentBlockContainer}>
                <Node {...detailsContainer}>{text}</Node>
                <Node {...contentBlockAnchorTag} href={imageLink} className={contentBlockAnchorTag ? contentBlockAnchorTag.className : ''}>
                    <Node {...imageContainer}>{image}</Node>
                </Node>
            </Module>
        );
    }
    return (
        <Module {...contentBlockContainer}>
            <Node {...detailsContainer}>{text}</Node>
            <Node {...imageContainer}>{image}</Node>
        </Module>
    );
};

export default HerbalIntroBlockView;
